import React from 'react';
import { ICategory } from 'types/possessions';

interface PossessionContextValue {
  categories: ICategory[],
  currentlyInStorylet: boolean,
  filterString: string,
  onFilter: (_: any) => void,
}

const PossessionContext = React.createContext<PossessionContextValue>({
  categories: [],
  currentlyInStorylet: false,
  filterString: '',
  onFilter: (_) => {},
});

PossessionContext.displayName = 'PossessionContext';

export default PossessionContext;